<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('store.recharge.title') }}</span>
          </div>
        </div>
      </div>
      <div class="ba_f mar_t20 pad_20">
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="storeName" :label="$t('store.list.storeName')" align="center"></el-table-column>
          <el-table-column :label="$t('store.recharge.amount')" align="center">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.type == '1' && parseFloat(scope.row.money) >= 0 ? '#67c23a' : 'red' }">
                {{ scope.row.type == '1' && parseFloat(scope.row.money) >= 0 ? '+' + scope.row.money : '-' + scope.row.money.replace(/\-/g, '') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="outTradeNo" :label="$t('store.recharge.orderNo')" align="center"></el-table-column>
          <el-table-column prop="createdAt" :label="$t('store.recharge.rechargeTime')" align="center"></el-table-column>
          <el-table-column prop="note" :label="$t('common.remark')" align="center"></el-table-column>
          <el-table-column prop="balance" :label="$t('store.recharge.currentBalance')" align="center"></el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { valueList } from '@/api/store';
export default {
  data() {
    return {
      formInline: {},
      list: [],
      listLoading: true,
      selectRows: '',
      page: { total: 0, pagesize: 10, currentPage: 1 },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    setSelectRows(val) {
      this.selectRows = val;
    },
    async fetchData() {
      const { data, count } = await valueList({ page: this.page.currentPage });
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    },
  },
};
</script>
